export var CAROUSEL_AUTOPLAY_TIMEOUT = 1500;
export var CAROUSEL_OVERFLOW_SPACING = 24;
export var CAROUSEL_CHEVRONS_WIDTH = {
  xs: 56,
  md: 60,
  lg: 64
};